import { NgModule } from '@angular/core';

import { OpinImageComponent } from './image.component';

@NgModule({
  declarations: [OpinImageComponent],
  exports: [OpinImageComponent]
})
export class OpinImageComponentModule {}
